<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-bring-forward`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 4a2 2 0 012 2v8h8a2 2 0 012 2v26a2 2 0 01-2 2H16a2 2 0 01-2-2v-8H6a2 2 0 01-2-2V6a2 2 0 012-2h26zM14 30V16a2 2 0 012-2h14V8H8v22h6z"/></svg>
</template>
<script>

export default {
  name: 'IconBringForward',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
